
import $api from "@/api/main";
import { defineComponent } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
export default defineComponent({
	props: {
		removeApiName: String,
		removeId: [String, Number],
		authCode: String,
		flowStatus: [String, Number],
		showWarn: {
			type: Boolean,
			default: false,
		},
		warnText: String
	},
	emits:['removeSuccess'],
	setup(props: any, { emit }: any) {
		const confirm = () => {
			ElMessageBox.prompt('请输入撤销原因', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputType:'textarea',
			})
			.then(({ value }) => {
				if(props.showWarn){
					ElMessageBox.confirm(
						`${props.warnText}`,
						'警告',
						{
							confirmButtonText: '确认撤销',
							cancelButtonText: '我再想想',
							type: 'warning',
						},
					)
					.then(async () => {
						$api[props.removeApiName](props.removeId,value).then((res: any) => {
							if (res) {
								ElMessage.success("撤销成功");
								emit("removeSuccess", true);
							}
						});
					})
				}else{
					$api[props.removeApiName](props.removeId,value).then((res: any) => {
						if (res) {
							ElMessage.success("撤销成功");
							emit("removeSuccess", true);
						}
					});
				}
			})
			.catch((e) => {
				console.log(e);
			})
		};
		return {
			confirm,
		};
	},
});
